module.exports = __webpack_public_path__ + "img/PG1_1-1-952x400.021ab843.png";